/* HARD LUCK SILVER — order window countdown
   Ticks down to a deadline, then swaps to the closed message on its own.
   No library, no dependencies. */

(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function init(root) {
    var raw = root.getAttribute('data-deadline');
    var target = raw ? new Date(raw.trim()) : null;

    var live = root.querySelector('[data-hls-cd-live]');
    var closed = root.querySelector('[data-hls-cd-closed]');
    var sr = root.querySelector('[data-hls-cd-sr]');
    if (!live || !closed) return;

    // A missing or unparseable date shouldn't leave a broken clock on the page.
    if (!target || isNaN(target.getTime())) {
      closed.hidden = false;
      return;
    }

    var d = root.querySelector('[data-cd-days]');
    var h = root.querySelector('[data-cd-hours]');
    var m = root.querySelector('[data-cd-mins]');
    var s = root.querySelector('[data-cd-secs]');
    var timer = null;

    function finish() {
      if (timer) clearInterval(timer);
      live.hidden = true;
      closed.hidden = false;
    }

    function tick() {
      var left = target.getTime() - Date.now();
      if (left <= 0) return finish();

      var secs = Math.floor(left / 1000);
      var days = Math.floor(secs / 86400);
      var hours = Math.floor((secs % 86400) / 3600);
      var mins = Math.floor((secs % 3600) / 60);
      var rem = secs % 60;

      d.textContent = pad(days);
      h.textContent = pad(hours);
      m.textContent = pad(mins);
      s.textContent = pad(rem);

      // Announce roughly, once a minute — not every second.
      if (sr && rem === 0) {
        sr.textContent = days + ' days, ' + hours + ' hours and ' + mins + ' minutes left to order.';
      }
    }

    live.hidden = false;
    closed.hidden = true;
    tick();
    timer = setInterval(tick, 1000);

    // Stop ticking while the tab is hidden, resync when it comes back.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (timer) clearInterval(timer);
        timer = null;
      } else if (!timer) {
        tick();
        timer = setInterval(tick, 1000);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-hls-countdown]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hls-countdown]').forEach(init);
  });
})();
